import { BarChart3, ClipboardList, Home, User, UserCircle, Users } from "lucide-react";
import { BottomNavigation } from "../ui/BottomNavigation.jsx";

import { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { getCurrentUser } from "../../services/authService.js";
import { getCompany } from "../../services/companyService.js";

export function MobileLayout({ children, showNavigation = true }) {
  const location = useLocation();
  const [userRole, setUserRole] = useState(null);
  const [loading, setLoading] = useState(true);
  const [hasCompany, setHasCompany] = useState(false);

  const salespersonNavItems = [
    { href: "/dashboard", icon: Home, label: "Dashboard" },
    { href: "/leads", icon: Users, label: "My Leads" },
    { href: "/account", icon: UserCircle, label: "Account" },
  ];

  const adminNavItems = [
    { href: "/dashboard", icon: Home, label: "Dashboard" },
    { href: "/leads", icon: Users, label: "Leads" },
    { href: "/team", icon: BarChart3, label: "Team" },
    { href: "/audit-logs", icon: ClipboardList, label: "Logs" },
    { href: "/account", icon: UserCircle, label: "Account" },
  ];

  useEffect(() => {
    let mounted = true;

    const fetchUserAndCompany = async () => {
      try {
        const userData = await getCurrentUser();
        if (!mounted) return;

        if (userData.success && userData.user && userData.user.user_role) {
          setUserRole(userData.user.user_role);

          if (userData.user.user_role === "business_admin") {
            const company = await getCompany();
            if (!mounted) return;
            setHasCompany(!!company);
          } else {
            setHasCompany(true);
          }
        } else {
          setUserRole("business_admin");
          setHasCompany(false);
        }

        setLoading(false);
      } catch (err) {
        if (!mounted) return;
        setUserRole("business_admin");
        setHasCompany(false);
        setLoading(false);
      }
    };

    fetchUserAndCompany();

    return () => {
      mounted = false;
    };
  }, []);

  if (loading) return null;

  if (!userRole && location.pathname !== "/add-team-member") {
    return <Navigate to="/" replace />;
  }

  // if (userRole === "business_admin" && !hasCompany &&
  //     location.pathname !== "/create-company" &&
  //     location.pathname !== "/add-team-member") {
  //   return <Navigate to="/create-company" replace />;
  // }

  const navItems =
    userRole === "business_admin" ? adminNavItems : salespersonNavItems;

  const shouldShowNav =
    showNavigation &&
    userRole &&
    !(
      userRole === "business_admin" &&
      !hasCompany &&
      (location.pathname === "/create-company" ||
        location.pathname === "/add-team-member")
    );

  return (
    <div className="min-h-[100dvh] bg-gradient-to-b from-[#ffffff] to-[#e6f0f7]">
      <main className={shouldShowNav ? "pb-16" : ""}>{children}</main>
      {shouldShowNav && <BottomNavigation items={navItems} />}
    </div>
  );
}
